import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CircularProgress, Box } from '@mui/material';

// eslint-disable-next-line react/prop-types
export function RequireAuth({ children }) {
    const navigate = useNavigate();
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);
    const hasRedirected = useRef(false);

    useEffect(() => {
        // Only redirect when auth check is complete and user is not authenticated
        // authStatus: 'configuring' = still checking, 'authenticated' = logged in, 'unauthenticated' = not logged in
        if (authStatus === 'unauthenticated' && !hasRedirected.current) {
            hasRedirected.current = true;
            navigate('/login');
        }
    }, [authStatus, navigate]);

    // Show loading spinner while auth state is being determined
    if (authStatus === 'configuring') {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Don't render children until authenticated
    if (authStatus !== 'authenticated') {
        return null;
    }

    return children;
}
